var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomCampaignPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 64,
    viewBox: "0 0 184 64",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 64,
    rx: 8,
    fill: "#25252F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 88,
    height: 10,
    rx: 3,
    fill: "#434350"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 120,
    height: 8,
    rx: 3,
    fill: "#2F2F39"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 42,
    width: 72,
    height: 8,
    rx: 3,
    fill: "#2F2F39"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 16,
    width: 24,
    height: 32,
    rx: 6,
    fill: "#434350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCampaignPlaceholder);
export default __webpack_public_path__ + "static/media/customCampaignPlaceholder.639f9cef74c2093dfd9e8c48858b7295.svg";
export { ForwardRef as ReactComponent };